import { Box, Typography } from '@mui/material'
import React from 'react'

export const GRAYBOOK_LOGO_URL =
  'https://firebasestorage.googleapis.com/v0/b/otw-production-91ffb.appspot.com/o/logos%2FGrayBook.png?alt=media&token=3bfd0cde-55b3-403c-a01b-19acfc48ee94'

interface PoweredByGrayBookProps {
  /** Text color for “Powered by” — use dark on light page chrome, light on dark headers. */
  variant?: 'light' | 'dark'
  /** Logo height; default fits most page headers. */
  size?: 'small' | 'medium'
  sx?: React.ComponentProps<typeof Box>['sx']
}

/**
 * Compact “Powered by GrayBook” mark for GrayBook-related pages (LTV, inventory pricing, calculator, formulas).
 */
const PoweredByGrayBook: React.FC<PoweredByGrayBookProps> = ({
  variant = 'light',
  size = 'medium',
  sx,
}) => {
  const logoHeight = size === 'small' ? 18 : 24

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        flexShrink: 0,
        ...sx,
      }}
    >
      <Typography
        variant='caption'
        sx={{
          color: variant === 'dark' ? 'rgba(255,255,255,0.85)' : 'text.secondary',
          fontWeight: 500,
          letterSpacing: 0.2,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Powered by
      </Typography>
      <Box
        component='img'
        src={GRAYBOOK_LOGO_URL}
        alt='GrayBook'
        sx={{
          height: logoHeight,
          width: 'auto',
          display: 'block',
          borderRadius: 0.5,
        }}
      />
    </Box>
  )
}

export default PoweredByGrayBook
